/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["link-preview-container{display:block;width:100%;height:100%;color:#fff;position:relative;overflow:hidden}link-preview-container.folder-link{background-color:#fff}link-preview-container.file-link{background-color:rgba(0,0,0,.9)}link-preview-container preview-container{margin:60px 0;min-height:calc(100% - 120px)}link-preview-container ad-host{margin-top:80px}"];
export { styles as styles };
